import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "./operationModel";

/** Модель операции */
export class BarcodeOperationModel extends OperationModel {
  public initData: Array<string> = [];

  public urlString: string = '';

  public newOperationRespondentCode: string = ''

  public parsedBarcode: string = '';
  public barcodeFormat: string | null = null;

  constructor(parsedBarcode: string, barcodeFormat: string | null) {
    super();
    this.parsedBarcode = parsedBarcode;
    this.barcodeFormat = barcodeFormat;
  }


  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;

    ord.setProperty("Barcode", this.parsedBarcode, DeclarationPropertiesTypes.String);
    ord.setProperty("BarcodeFormat", this.barcodeFormat, DeclarationPropertiesTypes.String);

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(ord:OperationRequestData): void {
    ord.keys.forEach((key: string) => {
      this.initData.push(`${key}=${ord.getPropertyValue(key)}`);
    });
    this.newOperationRespondentCode = ord.respondentCode;

    this.urlString =`/operation/0/${this.newOperationRespondentCode}?${this.initData.join("&")}`
  }
}

